require('bootstrap-switch-button');
